import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    estadoNutricional: [],
  },

  getters: {
    getEstadoNutricional: (state) => state.estadoNutricional,
  },

  mutations: {
    SET_ESTADO_NUTRICIONAL(state, estadoNutricional) {
      state.estadoNutricional = estadoNutricional;
    },
  },

  actions: {
    async fetchEstadoNutricional({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catEstadoNutriconal')
        .then((response) => {
          commit('SET_ESTADO_NUTRICIONAL', response.data.data);
        });
    },
  },
};
